




































import { Component, Vue, Ref } from "vue-property-decorator";
import { deleteUser } from "../../helpers/user-getter";

@Component
export default class DeleteAccount extends Vue {
  @Ref() readonly deleteAccountFormButton!: HTMLButtonElement;
  @Ref() readonly passwordInput!: HTMLInputElement;

  is_deleting = false;
  private password = "";
  private error = "";

  openDeletingForm(): void {
    this.is_deleting = true;
    this.$nextTick(() => this.passwordInput.focus());
  }

  closeDeletingForm(): void {
    this.is_deleting = false;
    this.$nextTick(() => this.deleteAccountFormButton.focus());
  }

  deleteAccount(): void {
    deleteUser(this.$store.state.user.id, this.password)
      .then((res) => {
        this.password = "";
        this.error = "";

        sessionStorage.removeItem("token");
        this.$router.replace("/register");
        this.$store.dispatch("clearUser");
      })
      .catch((err) => {
        this.error = err.message;
      });
  }
}
